import React, { Component } from 'react'
import Keen from 'keen-js'
import { object, string } from 'prop-types'

// utils
import { createQuery, runQuery, createQueryCTA, createQueryGambi } from '../../../utils/KeenReport'

// components
import Spinner from '../../Spinner'
import CompleteFunnelGraph from '../CompleteFunnelGraph'

class RegularFunnelWithClicks extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isLoading: true,
      hasError: false,
      recommendations: 0,
      plays: 0,
      videoPlays: 0,
      conversions: 0,
      link_requested: 0,
      url_expanded: 0,
      hasVideoPlay: false
    }

    this.runKeen = this.runKeen.bind(this)
    this.toggleVideoPlay = this.toggleVideoPlay.bind(this)
    this.prepareDataToGraph = this.prepareDataToGraph.bind(this)
  }
  componentDidMount () {
    this.runKeen(this.props)
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.timeframe !== this.props.timeframe) {
      this.runKeen(nextProps)
    }
  }
  toggleVideoPlay (hasVideoPlay) {
    this.setState({
      hasVideoPlay
    }, () => {
      this.prepareDataToGraph()
    })
  }
  prepareDataToGraph () {
    let { recommendations, plays, videoPlays, conversions, hasVideoPlay, url_expanded } = this.state
    let dataForGraph = [
      { label: 'Cliques', value: url_expanded, type: 'line', rate: 1, color: '#3de2e5' },
      { label: 'Visitas', value: recommendations, type: 'line', rate: (recommendations / url_expanded), color: '#1F77B4' },
      { label: 'Plays', value: plays, type: 'line', rate: (plays / recommendations), color: '#FF7F0E' }
    ]

    if (hasVideoPlay) {
      dataForGraph.push({ label: 'Player tocar video', value: videoPlays, type: 'line', color: '#ad48a1', rate: (videoPlays / plays) })
      dataForGraph.push({ label: 'Conversão', value: conversions, type: 'line', color: '#2CA02C', rate: (conversions / videoPlays) })
    } else {
      dataForGraph.push({ label: 'Conversão', value: conversions, type: 'line', color: '#2CA02C', rate: (conversions / plays) })
    }

    this.setState({
      isLoading: false,
      hasError: false,
      dataForGraph
    })
  }
  runKeen (props) {
    Keen.ready(() => {
      const { campaign, actor, timeframe, video, filters } = props
      let queries

      this.setState({
        isLoading: true,
        hasError: false
      })

      if (actor === 'pessoas') {
        queries = [
          createQuery('count_unique', 'video_recomended', timeframe, campaign, video, 'client_viewer_id', null, filters),
          createQuery('count_unique', 'video_unique_click', timeframe, campaign, video, 'client_viewer_id', null, filters),
          createQueryGambi('count_unique', 'video_unique_play', timeframe, campaign, video, 'client_viewer_id', null, filters)
        ]
        if (video && video.conversion_filter) {
          queries.push(createQueryCTA('count_unique', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', null, [...video.conversion_filter, ...filters]))
        } else {
          if (campaign && campaign.conversion_filter) {
            queries.push(createQuery('count_unique', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', null, [...campaign.conversion_filter, ...filters]))
          } else {
            queries.push(createQuery('count_unique', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', null, filters))
          }
        }
        queries.push(createQuery('count_unique', 'url_expanded', timeframe, null, video, 'viewer_id', null, filters))
      } else {
        queries = [
          createQuery('count', 'video_recomended', timeframe, campaign, video, null, null, filters),
          createQuery('count', 'video_unique_click', timeframe, campaign, video, null, null, filters),
          createQueryGambi('count', 'video_unique_play', timeframe, campaign, video, null, null, filters)
        ]
        if (video && video.conversion_filter) {
          queries.push(createQueryCTA('count', 'user_interacted', timeframe, campaign, video, null, null, [...video.conversion_filter, ...filters]))
        } else {
          if (campaign && campaign.conversion_filter) {
            queries.push(createQuery('count', 'user_interacted', timeframe, campaign, video, null, null, [...campaign.conversion_filter, ...filters]))
          } else {
            queries.push(createQuery('count', 'user_interacted', timeframe, campaign, video, null, null, filters))
          }
        }
        queries.push(createQuery('count', 'url_expanded', timeframe, null, video, null, null, filters))
      }
      runQuery(queries)
        .then((res) => {
          let recommendations = res[0].result
          let plays = res[1].result
          let videoPlays = res[2].result
          let conversions = res[3].result
          let url_expanded = res[4].result

          this.setState({
            recommendations,
            plays,
            videoPlays,
            conversions,
            url_expanded
          }, () => {
            this.prepareDataToGraph()
          })
        }, (err) => {
          console.log('Erro rodando a query do Keen.', err)
          this.setState({
            hasError: true
          })
        })
    })
  }
  render () {
    let { isLoading, hasError } = this.state
    return (
      <div>
        <div className={isLoading ? 'hidden' : ''}>
          <CompleteFunnelGraph
            dataForGraph={this.state.dataForGraph}
            toggleVideoPlay={this.toggleVideoPlay}
            funnelType={this.props.funnelType}
          />
        </div>
        <Spinner isLoading={isLoading} hasError={hasError} runKeen={() => { this.runKeen(this.props) }} />
      </div>
    )
  }
}

RegularFunnelWithClicks.propTypes = {
  timeframe: object,
  campaign: object,
  actor: string,
  video: object
}

export default RegularFunnelWithClicks



// WEBPACK FOOTER //
// ./src/components/charts/Funnels/RegularFunnelWithClicks.js